import { create } from 'zustand'
import { postData } from 'helpers/api'

export const useCategoriesStore = create((set) => ({
  categories: {},

  setCategories: async () => {
    const data = await postData('categories/')
    set({ categories: data })
    return data
  }
}))
